import { Component, Input, OnInit } from '@angular/core';
import { OrderService } from 'src/app/order/services/order.service';
import { DashboardStateServiceService } from '../../services/dashboard-state-service.service';
import { forkJoin, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

@Component({
    selector: 'app-orders-by-status-graph',
    templateUrl: './orders-by-status-graph.component.html',
    styleUrls: ['./orders-by-status-graph.component.scss'],
    standalone: false
})
export class OrdersByStatusGraphComponent implements OnInit {
  @Input() startDate: string;
  @Input() endDate: string;

  dataBar: any[] = [];
  loaded: boolean = false;

  view: any[] = [];
  gradient: boolean = false;
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'Orders';

  colorScheme = {
    domain: ['#1a1a1a', '#5AA454', '#e51c23']
  };

  constructor(
    private orderService: OrderService,
    private dashboardStateService: DashboardStateServiceService
  ) { }

  ngOnInit(): void {
    this.dashboardStateService.$datesChanged.subscribe(() => {
      this.loadContent();
    });

    this.loadContent();
  }

  loadContent(): void {
    forkJoin({
      pending: this.orderService.getOrderCountByStatus('Pending', this.startDate, this.endDate).pipe(catchError(() => of(0))),
      accepted: this.orderService.getOrderCountByStatus('Accepted', this.startDate, this.endDate).pipe(catchError(() => of(0))),
      declined: this.orderService.getOrderCountByStatus('Declined', this.startDate, this.endDate).pipe(catchError(() => of(0))),
    })
    .pipe(take(1))
    .subscribe((counts) => {
      this.dataBar = [
        { name: 'Pending', value: counts.pending },
        { name: 'Accepted', value: counts.accepted },
        { name: 'Declined', value: counts.declined },
      ];
      this.loaded = true;
    });
  }

}
